import { combineReducers } from 'redux';
import { useDispatch, useSelector } from 'react-redux';
import { auth } from './auth';
import { startApp } from '../actions/AppActions';
import realTimeReducer from '../RealTimeNotificationHandlers/Reducer';
import sidebarReducer from './sidebar';
import teaseReducer from './tease';
import floatingReducer from './floating';
export function useAppDispatch() {
  return useDispatch();
}
export function useAppSelector(selector) {
  return useSelector(selector);
}
export const rootReducer = combineReducers({
  auth,
  floating: floatingReducer,
  realTimeNotifications: realTimeReducer,
  sidebar: sidebarReducer,
  tease: teaseReducer
});
export const initialState = rootReducer(undefined, startApp());